import { TableRow } from "@mcleod/components";
import { AutogenLayoutScreenCodeList } from "./autogen/AutogenLayoutScreenCodeList";

export class ScreenCodeList extends AutogenLayoutScreenCodeList {

    override onLoad() {
        this.mainDataSource.search();
        this.overrideUrlParam();
    }


    private overrideUrlParam() {
        this.tableScreenCode.overrideUrlParams = (selectedRow: TableRow) => {
            return {
                key: selectedRow.data.get("field_table_alias"),
                fieldCode: selectedRow.data.get("field_code"),
                fieldName: selectedRow.data.get("field_name")
            };
        };
    }
}
